import React from 'react'

import { Box, Typography } from '@mui/material'
import { useDocPreview } from 'hooks/useDocPreview'
import ImageCrop from 'components/ImageCrop'
import { NEW_CONTAINER_WIDTH, NEW_RES_ACCORDIAN_WIDTH, VECHILE_CONTAINER_WIDTH } from 'constants/layoutConstant'
import { MESSAGES } from '../messages/messages'

const EditPreview = () => {
    const { editPreview } = useDocPreview()
    const { base64Data, mimeType } = editPreview

    const src = `data:${mimeType};base64,${base64Data}`

    return (
        <Box
            sx={{
                backgroundColor: 'common.white.main',
                px: { xs: 4, md: 4 }
            }}
        >
            <Box
                sx={{
                    backgroundColor: 'common.white.main',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: 6, smd: 12, md: 22 },
                    px: { xs: 0, md: 10 },
                    maxWidth: NEW_CONTAINER_WIDTH,
                    margin: 'auto',
                    width: '100%'
                }}
            >
                <Typography
                    data-testid="document_upload_title"
                    sx={{
                        color: 'common.charcoal.main',
                        typography: { xs: 'smallHeadline4', md: 'smallHeadline0' },
                        fontWeight: 600
                    }}
                >
                    {MESSAGES.document_upload}
                </Typography>

                <Box
                    sx={{
                        maxWidth: {
                            xs: 'initial',
                            smd: NEW_RES_ACCORDIAN_WIDTH,
                            md: VECHILE_CONTAINER_WIDTH
                        },
                        margin: 'auto',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 14
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 4,
                            width: '100%'
                        }}
                    >
                        <Box
                            data-testid="driver_edit_title"
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', smd: 'row' },
                                gap: { xs: 1, smd: 1.5 }
                            }}
                        >
                            <Typography
                                sx={{
                                    color: 'common.charcoal.main',
                                    typography: { xs: 'regularSubTitle', md: 'smallHeadline3' }
                                }}
                            >
                                {MESSAGES.edit_image}
                            </Typography>
                        </Box>

                        <Box
                            data-testid="driver_edit_sub"
                            sx={{
                                display: 'flex',
                                gap: 1,
                                flexWrap: 'wrap',
                                columnGap: 4
                            }}
                        >
                            <Typography
                                component={'span'}
                                sx={{
                                    color: 'common.charcoal.main',
                                    typography: 'regularBody1'
                                }}
                            >
                                {MESSAGES.edit_or_replace}
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        data-testid="driver_edit_block"
                        sx={{
                            mb: 22
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                m: '0 auto',
                                pb: 7,
                                px: { xs: 2, md: 0 },
                                backgroundColor: '#FAFAFA'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                {src && <ImageCrop url={src} />}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default EditPreview
